import * as React from "react";

function SvgIcSearch(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 11a5 5 0 11-10 0 5 5 0 0110 0zm-.808 5.606a7 7 0 111.414-1.414l3.101 3.1a1 1 0 01-1.414 1.415l-3.1-3.1z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcSearch;
